import { BaseDto } from "src/dtos/common/baseDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface EmployeeDto extends BaseDto {
	empNo: string; 						// 사원번호
	empNm: string; 						// 사원명
	ename: string; 						// 영문이름
	cname: string; 						// 중문이름
	compCd: string; 					// 사업장코드
	resnoBirth: string;					// 생년월일-주민번호
	resnoLastkey: string;				// 주민번호뒤자리
	orgCd: string;						// 조직코드 - 부서
	cardNo: string;						// 출입증No
	empSts: string;						// 재직상태
	workArea: string;					// 근무지역
	empDt: string | undefined;			// 입사일
	compJoinType: string;				// 입사구분
	retireDt: string | undefined;		// 퇴사일
	retireType: string;					// 퇴사구분
	positionCd: string;					// 직위코드
	jobClass: string;					// 직군
	jobPosition: string;				// 직책
	positionDt: string | undefined;		// 죄종 승진일자
	siteWorkYn: string;					// 현장근무여부
	payType: string;					// 급여구분
	baseAddress: string;				// 기본주소
	post: string;						// 우편번호
	address: string;					// 주소
	detailAddress: string;				// 상세주소
	otherAddress: string;				// 기타주소
	addressFull: string;				// 전체주소
	birthdayType: string;				// 생일구분
	birthday: string | undefined;		// 생일
	weddingYn: string;					// 결혼여부
	weddingDt: string | undefined;		// 결혼일
	educationLevel: string;				// 학력
	educationNm: string;				// 최종학교명
	telNo: string;						// 전화번호
	mobileNo: string;					// 휴대폰번호
	email: string;						// 이메일
	meritPersonYn: string;				// 국가유공자여부
	carType: string;					// 차종
	carNm: string;						// 차명
	carNo: string;						// 차량번호
	yearVacationDt: string | undefined;	// 연차기준일
	retireInterimDt: string | undefined;	// 퇴직중도정산일(퇴직금정산일)
	country: string;					// 국적
	officeTel: string;					// 사무실전화
	officeFax: string;					// 사무실팩스
	foreignYn: string;					// 외국인여부
	remark: string;						// 비고
	insertDt: Date;						// 등록일
	insertUser: string;					// 등록자
	insertForm: string;					// 등록화면
	updateDt: Date;						// 수정일
	updateUser: string;					// 수정자
	updateForm: string;					// 수정폼
}



//기본 인터페이스스
export const defaultEmployee: EmployeeDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
    empNo: '',
    empNm: '',
    ename: '',
    cname: '',
    compCd: '',
    resnoBirth: '',
    resnoLastkey: '',
    orgCd: '',
    cardNo: '',
    empSts: '',
    workArea: '',
    empDt: formatDate(new Date()),
    compJoinType: '',
    retireDt: formatDate(new Date()),
    retireType: '',
    positionCd: '',
    jobClass: '',
    jobPosition: '',
    positionDt: formatDate(new Date()),
    siteWorkYn: '',
    payType: '',
    baseAddress: '',
    post: '',
    address: '',
    detailAddress: '',
    otherAddress: '',
    addressFull: '',
    birthdayType: '',
    birthday: formatDate(new Date()),
    weddingYn: '',
    weddingDt: formatDate(new Date()),
    educationLevel: '',
    educationNm: '',
    telNo: '',
    mobileNo: '',
    email: '',
    meritPersonYn: '',
    carType: '',
    carNm: '',
    carNo: '',
    yearVacationDt: formatDate(new Date()),
    retireInterimDt: formatDate(new Date()),
    country: '',
    officeTel: '',
    officeFax: '',
    foreignYn: '',
    remark: '',
    insertDt: new Date(),
    insertUser: '',
    insertForm: '',
    updateDt: new Date(),
    updateUser: '',
    updateForm: ''
}
